export default __webpack_public_path__ + "static/media/banner-02@2x.82ef9329.png";